<template>
  <label :for="randomSelectId" class="radio-btn-single" >
    {{ text }}
    <input
      :id="randomSelectId"
      :checked="checked"
      type="radio"
      :name="name"
      :value="value"
      @change="emitChange"/>
    <span class="checkmark"></span>
  </label>
</template>

<script>
export default {
  name: 'RadioButton',
  props: {
    name: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: false,
    };
  },
  computed: {
    randomSelectId() {
      return `radio-${this.randomNumber()}`
    },
  },
  methods: {
    emitChange() {
      this.$emit('input', this.value);
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
  },
}
</script>
